import styled from '@emotion/styled';
import { Colors, media, helperBgBlured } from '@utex/ui-kit';

export const Container = styled('div')`
  ${helperBgBlured};
  position: sticky;
  z-index: 3;
  bottom: 0;
  box-shadow: 0 -1px 0 ${Colors.rgbaBlack10};
  padding-bottom: env(
    safe-area-inset-bottom,
    0
  ); /*стиль для длинных айфонов, заработает только вместе с правильным вьюпортом*/

  @media ${media.desktop} {
    display: none;
  }
`;
